export const playerActions = {
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  MUTE: 'MUTE',
  UNMUTE: 'UNMUTE',
  SEEK: 'SEEK',
  ALTSEEK: 'ALTSEEK', // used to trick useEffect in toolbox to send message on seek
  SHOWCONTROLS: 'SHOW CONTROLS',
  HIDECONTROLS: 'HIDE CONTROLS',
  SHOWSUBTITLES: 'SHOW SUBTITLES',
  HIDESUBTITLES: 'HIDE SUBTITLES',
};

export const subtitlesModes = {
  SHOWING: 'showing',
  HIDDEN: 'hidden',
};

export const transcriptModes = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  VIEWOPTIONS: 'VIEWOPTIONS',
  ASSIGNSPEAKERS: 'ASSIGNSPEAKERS',
};
